      document.addEventListener("DOMContentLoaded", function () {
        const showMoreBtnsDesktop = document.querySelectorAll(
          "#showMoreBtnDesktop"
        );
        const showMoreBtnsMobile =
          document.querySelectorAll("#showMoreBtnMobile");
        const overlay = document.querySelector(".fum-gradient-overlay-bottom");
        const container = document.querySelector(
          ".fum-featured-press-container"
        );
        const cardGrid = document.querySelector(
          ".fum-featured-press-card-grid"
        );
        const moreItemsGrid = document.querySelector(
          ".fum-featured-press-more-items-card-grid"
        );

        showMoreBtnsDesktop.forEach((btn) => {
          btn.addEventListener("click", function () {
            toggleShowMore(moreItemsGrid, btn, cardGrid, "24px", "0px");
          });
        });

        showMoreBtnsMobile.forEach((btn) => {
          btn.addEventListener("click", function () {
            toggleShowMore(moreItemsGrid, btn, cardGrid, "24px", "24px");
            toggleOverlay(container, overlay, btn);
          });
        });

        function toggleShowMore(moreItemsGrid, btn, cardGrid, gapOne, gapTwo) {
          if (moreItemsGrid.classList.contains("show")) {
            moreItemsGrid.classList.remove("show");
            btn.textContent = "Show more";
            moreItemsGrid.addEventListener(
              "transitionend",
              function handleTransitionEnd() {
                cardGrid.style.rowGap = gapTwo;
                moreItemsGrid.removeEventListener(
                  "transitionend",
                  handleTransitionEnd
                );
              }
            );
          } else {
            moreItemsGrid.classList.add("show");
            btn.textContent = "Show less";
            cardGrid.style.rowGap = gapOne;
          }
        }

        function toggleOverlay(container, overlay,btn) {
  const thirdCard = document.querySelector(".fum-featured-press-card:nth-child(3)");

  if (overlay.style.display === "none") {
    overlay.style.display = "flex";
    container.style.height = "100vh";
    container.style.overflow = "hidden";

    // Scroll to the top of the component (container)
    container.scrollIntoView({ behavior: "smooth" });
      btn.textContent = "Show less ";
  } else {
    overlay.style.display = "none";
    container.style.height = "100%";
    container.style.overflow = "auto";

    // Scroll to the third card
    thirdCard.scrollIntoView({ behavior: "smooth" });
      btn.textContent = "Show  more";
  }
}


      });